import { render, staticRenderFns } from "./CookieTemplate.vue?vue&type=template&id=52319b39&scoped=true&"
import script from "./CookieTemplate.vue?vue&type=script&lang=js&"
export * from "./CookieTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CookieTemplate.vue?vue&type=style&index=0&id=52319b39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52319b39",
  null
  
)

export default component.exports